import { render } from "./MPCCriticality.vue?vue&type=template&id=2865d844&scoped=true&ts=true"
import script from "./MPCCriticality.vue?vue&type=script&lang=ts"
export * from "./MPCCriticality.vue?vue&type=script&lang=ts"

import "./MPCCriticality.vue?vue&type=style&index=0&id=2865d844&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2865d844"]])

export default __exports__